// Tiny module-local signal so the Overview can tell the Tasks page to land
// pre-filtered on a category / owner / etc. Kept in memory (not URL) since
// the app is SPA and the route is identified by `active` state.

export type TaskFilter = {
  owner?: string;   // filter by owner (match contains)
  category?: string;
  phase?: string;
};

let pending: TaskFilter | null = null;
const listeners = new Set<(f: TaskFilter | null) => void>();

export function setTaskFilter(f: TaskFilter | null) {
  pending = f;
  listeners.forEach((l) => l(f));
}

export function consumeTaskFilter(): TaskFilter | null {
  const f = pending;
  pending = null;
  return f;
}
